var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.c()},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}),_vm._v(" "),_c('a',{class:['btn btn__primary', _vm.c('button')],attrs:{"href":_vm.href}},[_vm._v("\n    "+_vm._s(_vm.textButton)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }